export default __webpack_public_path__ + "static/media/mixed-gas-banner.eb2fd344.jpg";